import Swal from 'sweetalert2';
window.Swal = Swal;

export function swalFireError(message) {
    Swal.fire({
        icon: 'error',
        title: 'Error...',
        html: message
    });
}

export function swalFireSuccess(message) {
    Swal.fire({
        icon: 'success',
        title: 'Success',
        text: message
    });
}

export function showErrors(errors) {
    let errorMessage = '';
    for (const key in errors) {
        if (errors.hasOwnProperty(key)) {
            errorMessage += errors[key][0] + '\n';
        }
    }
    swalFireError(errorMessage);
}
